import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// 導入翻譯資源
import zhTW from "./locales/zhTW/index.json";
import en from "./locales/en/index.json";

const resources = {
  zhTW: {
    translation: zhTW,
  },
  en: {
    translation: en,
  },
};

i18n
  .use(initReactI18next) // 使用 react-i18next
  .init({
    resources,
    lng: "zhTW", // 預設語言
    fallbackLng: "zhTW", // 後備語言

    interpolation: {
      escapeValue: false, // React 已經安全處理了
    },

    // 調試選項（生產環境可以關閉）
    debug: process.env.NODE_ENV === "development",
  });

export default i18n;
